var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.99996C18.3333 5.39996 14.6 1.66663 9.99996 1.66663C5.39996 1.66663 1.66663 5.39996 1.66663 9.99996C1.66663 14.0333 4.53329 17.3916 8.33329 18.1666V12.5H6.66663V9.99996H8.33329V7.91663C8.33329 6.30829 9.64163 4.99996 11.25 4.99996H13.3333V7.49996H11.6666C11.2083 7.49996 10.8333 7.87496 10.8333 8.33329V9.99996H13.3333V12.5H10.8333V18.2916C15.0416 17.875 18.3333 14.325 18.3333 9.99996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundFacebookBlack);
export default __webpack_public_path__ + "static/media/ic_round-facebook_black.63fd34e86227914aa92868437a67cdb3.svg";
export { ForwardRef as ReactComponent };